import { Spin } from 'antd';

interface StateProps {
    loading: boolean;
    children?: React.ReactNode;
}

const Fallback = ({ loading }: StateProps) => {
    if (!loading) return <div />;
    return (
        <div className="FallbackWrapper">
            <Spin spinning={true} tip="Načítám data..." size="large" className="Fallback" />
        </div>
    );
}

export default Fallback;